module.exports = __webpack_public_path__ + "78793ce53f721fa05784a0269a4d6a52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Purple2.jpg
// module id = 12
// module chunks = 0